import { LicenseStates } from './local-data';

export const CERTIFICATES_STATES = {
  ...LicenseStates,
};
